export default __webpack_public_path__ + "static/media/1.61f96e27.png";